<template>
    <div class="page-container">
        <div class="level-box">
            <img :src="pageData.url" alt="" class="account-icon">
            <div class="user-level">
                {{
                    pageData.level == 1 ? '普通用户' :
                    pageData.level == 2 ? '合伙人' :
                    pageData.level == 3 ? '高级合伙人' : '战略合伙人'
                }}
            </div>
        </div>
        <div class="account-box">
            <div class="toplinks">
                <router-link to="/account/detail" class="link-item">账户明细</router-link>
            </div>
            <div class="account-total">
                <div class="total-title">账户余额(元)</div>
                <div class="total-num">{{pageData.amount}}</div>
            </div>
            <div class="in-out-box">
                <div class="box-item">
                    <div class="box-title">总订货金额</div>
                    <div class="box-num">{{pageData.repairTotal}}</div>
                </div>
                <div class="box-item">
                    <div class="box-title">已进货金额</div>
                    <div class="box-num">{{pageData.takeTotal}}</div>
                </div>
            </div>
            <div class="btn-normal" @click="jumpBh">继续补货</div>
        </div>
        <div class="bottom-links">
            <router-link to="/reward/rules?role=partner" class="link-item">合伙规则</router-link>
        </div>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast} from 'vant'

export default {
    data(){
        return {
            pageData:{}
        }
    },
    components:{
        [Toast.name]:Toast
    },
    activated(){
        $http({
            method:'post',
            url:config.api.accountOverview
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        jumpBh(){
            this.$router.push({
                name:'replenishment-apply'
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.page-container{
    background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
    min-height: 100vh;
    padding:0 10px;
    .level-box{
        padding:28px 0;
        text-align: center;
        .account-icon{
            width:50px;
            height:50px;
            border-radius: 50%;
            background:#d8d8d8;
            margin-bottom: 12px;
        }
        .user-level{
            font-size: 16px;
            color:#fff;
        }
    }
    .account-box{
        background:#fff;
        padding-bottom: 66px;
        @media screen and (max-width:750px){
            border-radius: 4px;
        }
        .toplinks{
            padding:20px;
            text-align: right;
            .link-item{
                font-size: 14px;
                color:#3089F5;
                line-height: 20px;
            }
        }
        .account-total{
            text-align: center;
            margin-bottom: 36px;
            .total-title{
                font-size: 14px;
                color:#333;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 10px;
            }
            .total-num{
                font-size: 34px;
                color:#333;
                line-height: 40px;
                font-weight: bold;
                font-family: DINAlternate-Bold, DINAlternate;
            }
        }
        .in-out-box{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 66px;
            .box-item{
                width:50%;
                box-sizing: border-box;
                text-align: center;
                &:first-child{
                    border-right: 1px solid #dcdcdc;
                }
                .box-title{
                    font-size: 14px;
                    color: #333;
                    line-height: 20px;
                    margin-bottom: 8px;
                    opacity: 0.5;
                }
                .box-num{
                    font-size: 24px;
                    color:#333;
                    line-height: 28px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                }
            }
        }
        .btn-normal{
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            @media screen and (max-width:750px){
                border-radius: 28px;
            }
            font-size: 16px;
            color:#fff;
            margin:0 auto;
        }
    }
    .bottom-links{
        width:100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        text-align: center;
        padding-bottom: 10px;
        .link-item{
            font-size: 14px;
            color:#fff;
            line-height: 20px;
        }
    }
}
</style>